﻿/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { RadioButtonValg, RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import { RadioButtonDisplay } from '../../Shared/Scripts/Components/ValgDisplayFunctions';
import VeilederStegComponent, {
    VeilederStegBaseProps,
    VeilederStegDefaultProps,
} from '../../Shared/Scripts/Components/VeilederStegComponent';
import getLabelValue from '../../Shared/Scripts/Utilities/InputUtilities';
import Valg from '../../Shared/Scripts/Models/Valg';
import { connect } from 'react-redux';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { hasParentWithClass } from '../../Shared/Scripts/Utilities/ElementUtilies';
import VeilederBsDto from '../Models/VeilederBsDto';
import { VeilederBsAppState } from '../Store';

type RadioButtonsStegOwnProps<T> = VeilederStegDefaultProps &
    VeilederStegBaseProps & {
        sporsmal: keyof VeilederBsDto;
        value?: Valg<string>;
        valg: Array<RadioButtonValgModel<VeilederBsDto>>;
        onInputChange(valg: Valg<string>): void;
        stipendBelop: JSX.Element | null;
    };

type RadioButtonsStegProps<T> = RadioButtonsStegOwnProps<T> & MapStateToProps & MapDispatchToProps;

class CustomRadioButtonsStegComponent<T> extends React.PureComponent<RadioButtonsStegProps<T>> {
    static defaultProps: VeilederStegDefaultProps = {
        neverCollapse: false,
    };

    constructor(props: RadioButtonsStegProps<T>) {
        super(props);

        this.onInputChange = this.onInputChange.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
    }

    onMouseUp = (event: React.MouseEvent): void => {
        const { neverCollapse, sporsmalId, stegVisningSetCollapsed } = this.props;
        if (
            neverCollapse !== true &&
            event.target != null &&
            hasParentWithClass(event.target as Element, 'c-radio-input')
        ) {
            stegVisningSetCollapsed({ id: sporsmalId, isCollapsed: true });
        }
    };

    onInputChange = (e: React.FormEvent<HTMLDivElement>): void => {
        const { onInputChange } = this.props;
        const inputSource = e.target as HTMLInputElement;
        const newValue = {
            displayValue: getLabelValue(inputSource) as string,
            value: inputSource.value,
            id: inputSource.id,
        };

        onInputChange(newValue);
    };

    render(): JSX.Element {
        const {
            sporsmalId,
            valg,
            tittel,
            forklaring,
            stipendBelop,
            sporsmal,
            neverCollapse,
            classModifier,
            customBottomRow,
            value,
            epiContext,
        } = this.props;

        const gruppe = sporsmalId;
        const radioValg = valg.map((v: RadioButtonValgModel<VeilederBsDto>) =>
            RadioButtonValg<VeilederBsDto>(
                gruppe,
                v.id,
                v.value,
                v.tekst as keyof VeilederBsDto,
                value ? value.id === v.id : false,
                epiContext,
            ),
        );

        const display = value ? RadioButtonDisplay(gruppe, value) : null;
        return (
            <VeilederStegComponent
                sporsmalId={sporsmalId}
                tittel={tittel}
                forklaring={forklaring}
                inputArea={
                    <div>
                        <div className="c-veileder__inputomrade">
                            {stipendBelop}
                            <fieldset className="c-veileder__fieldset">
                                <legend>
                                    <span className="c-veileder__undersporsmal">{contentResolver(epiContext, sporsmal)}</span>
                                </legend>                       
                                <div className="c-veileder__radioknapper-container" onMouseUp={this.onMouseUp} onChange={this.onInputChange}>
                                    {radioValg}
                                </div>
                            </fieldset>
                        </div>
                    </div>
                }
                displayElement={display}
                canCollapse={value !== undefined}
                neverCollapse={neverCollapse}
                classModifier={classModifier}
                customBottomRow={customBottomRow}
            />
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederBsDto>;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: VeilederBsAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
    { stegVisningSetCollapsed: setCollapsed },
)(CustomRadioButtonsStegComponent);
